module.exports = __webpack_public_path__ + "907c3298ccb1fc38ae2ebd15b40a4907.pdf";